import { createSimpleFunctional } from '@/util'

export const VBreadcrumbsDivider = createSimpleFunctional('v-breadcrumbs-divider', 'li')

export type VBreadcrumbsDivider = InstanceType<typeof VBreadcrumbsDivider>
